export enum AssociatedProductType {
  Mandatory,
  Optional
}